import { Signal } from "@lit-labs/signals";
import type { ProfileDataResult } from "api-contracts/rpc/profile-data";
import type { ICreatorProfileDataState } from "./types";

export class CreatorProfileDataState implements ICreatorProfileDataState {
  readonly profile = new Signal.State<ProfileDataResult | null>(null);
  readonly loading = new Signal.State<boolean>(false);
}
